export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Staff.vue?vue&type=template&id=6bfac854"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Customers/Staff.vue?vue&type=template&id=6bfac854
// module id = 2556
// module chunks = 31